import { render, staticRenderFns } from "./SMRejectMorPurDialog.vue?vue&type=template&id=316bb251&"
import script from "./SMRejectMorPurDialog.vue?vue&type=script&lang=js&"
export * from "./SMRejectMorPurDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports